import { Navigate, Outlet } from 'react-router-dom'
import useToken from '../hooks/useToken'
import Navbar from './Navbar'

const Layout = () => {
  const { token } = useToken()

  return token ? (
    <div className='bg-primary text-white min-h-screen'>
      <Navbar />
      <div className='pb-24'>
        <Outlet />
      </div>
    </div>
  ) : (
    <Navigate to='/login' />
  )
}

export default Layout
